import { render } from "./monoChoice.vue?vue&type=template&id=357b0d19"
import script from "./monoChoice.vue?vue&type=script&lang=js"
export * from "./monoChoice.vue?vue&type=script&lang=js"

import "./monoChoice.vue?vue&type=style&index=0&id=357b0d19&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__